module.exports = __webpack_public_path__ + "img/icn_checkbox_off.fa99ac6c.svg";